<template>
  <div class="AdditionalGoals PrimaryGoals">
    <div id="form-div">
      <div class="row justify-content-left align-items-left">
        <div class="col-md-12 px-4">
          <span v-if="primaryGoalsViewMode === 'primary'">
            {{ $t('wheelAnalysis.primaryGoals.modes.primary.title') }}
          </span>
          <span v-if="primaryGoalsViewMode === 'secondary'">
            {{ $t('wheelAnalysis.primaryGoals.modes.secondary.title') }}
          </span>
          <span v-if="primaryGoalsViewMode === 'sweep'">
            {{ $t('wheelAnalysis.primaryGoals.modes.sweep.title') }}
          </span>
          <span v-if="primaryGoalsViewMode === 'review'">
            {{ $t('wheelAnalysis.primaryGoals.modes.review.title') }}
          </span>

          <div v-if="primaryGoalsViewMode === 'primary'" class="sidebar-instructions">
            {{ $t('wheelAnalysis.primaryGoals.modes.primary.instructions') }}
          </div>
          <div v-if="primaryGoalsViewMode === 'secondary'" class="sidebar-instructions">
            {{ $t('wheelAnalysis.primaryGoals.modes.secondary.instructions') }}
          </div>
          <div v-if="primaryGoalsViewMode === 'sweep'" class="sidebar-instructions">
            {{ $t('wheelAnalysis.primaryGoals.modes.sweep.instructions') }}
          </div>
          <div v-if="primaryGoalsViewMode === 'review'" class="sidebar-instructions">
            {{ $t('wheelAnalysis.primaryGoals.modes.review.instructions') }}
          </div>

          <MDBAccordion v-model="activeGoalItem" borderless>
            <div v-for="(goal, index) in goals" :key="goal.id">
              <div>
                <MDBAccordionItem
                    :headerTitle="goal.name"
                    :collapseId="'collapse' + goal.id"
                    :icon="'icon-sdg icon-sdg-' + String(goal.id).padStart(2, '0')"
                >
                  <MDBCheckbox
                      :disabled="!editMode"
                      v-model="selectedGoals[index]"
                      :id="goal.id"
                      :label="goal.id + ': ' + goal.description"
                      size="large"
                      style="font-weight:bold"
                  />

                  <br />

                  <strong>{{ $t('wheelAnalysis.primaryGoals.targetsLabel') }}</strong>

                  <div v-for="(target, targetIndex) in goal.targets" :key="target.id">
                    <MDBCheckbox
                        :disabled="!editMode"
                        v-model="selectedTargets[index][targetIndex]"
                        :id="target.id"
                        :label="target.id + ': ' + target.name"
                        size="small"
                    />
                  </div>
                </MDBAccordionItem>
              </div>
            </div>
          </MDBAccordion>
        </div>
      </div>
    </div>
  </div>

  <router-view />
</template>

<script src="./_PrimaryGoals.js" lang="js"></script>
<style src="./_PrimaryGoals.less" lang="less"></style>
